import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ExcessStockService from '../services/excess-stock.service';
import {setMessage} from './message';

export const fetchExcessStockBundlesSummary = createAsyncThunk(
  'excessStock/fetchExcessStockBundlesSummary',
  async ({page, pagesize, search, ordering}, thunkAPI) => {
    try {
      const response = await ExcessStockService.getExcessStockBundlesSummary(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchExcessStockPrintById = createAsyncThunk(
  'excessStock/fetchExcessStockPrintById',
  async ({id, page, pagesize, search, ordering}, thunkAPI) => {
    try {
      const response = await ExcessStockService.getExcessStockPrintById(
        id,
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data; // Return the profile data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const fetchExcessBundlesSummary = createAsyncThunk(
  'excessStock/fetchExcessBundlesSummary',
  async ({page, pagesize, search, ordering}, thunkAPI) => {
    try {
      const response = await ExcessStockService.getExcessBundlesSummary(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchExcessStockBundlesById = createAsyncThunk(
  'excessStock/fetchExcessStockBundlesById',
  async ({id, page, pagesize, search, ordering}, thunkAPI) => {
    try {
      const response = await ExcessStockService.getExcessStockById(
        id,
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data; // Return the profile data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchExcessStockBundles = createAsyncThunk(
  'excessStock/fetchExcessStockBundles',
  async ({page, pagesize, search, groupId, ordering}, thunkAPI) => {
    try {
      const response = await ExcessStockService.getExcessStockBundles(
        page,
        pagesize,
        search,
        groupId,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchArchivedExcessStockBundlesSummary = createAsyncThunk(
  'excessStock/fetchArchivedExcessStockBundlesSummary',
  async ({page, pagesize, search, ordering}, thunkAPI) => {
    try {
      const response =
        await ExcessStockService.getArchiveExcessStockBundlesSummary(
          page,
          pagesize,
          search,
          ordering,
        );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchArchivedExcessStockBundles = createAsyncThunk(
  'excessStock/fetchArchivedExcessStockBundles',
  async ({page, pagesize, search, ordering}, thunkAPI) => {
    try {
      const response = await ExcessStockService.getArchiveExcessStockBundles(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const createExcessStock = createAsyncThunk(
  'excessStock/createExcessStock',
  async ({values}, thunkAPI) => {
    try {
      const response = await ExcessStockService.addExcessStock(values);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const ShiftBundletoWorkOrder = createAsyncThunk(
  'excessStock/ShiftBundleToWorkOrder',
  async ({values}, thunkAPI) => {
    try {
      const response =
        await ExcessStockService.ShiftBundleToExcessStock(values);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const updateExcessStock = createAsyncThunk(
  'excessStock/updateExcessStock',
  async ({id, values}, thunkAPI) => {
    try {
      const response = await ExcessStockService.updateExcessStock(id, values);
      return response.data; // Return the updated die group data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteExcessStock = createAsyncThunk(
  'excessStock/deleteExcessStock',
  async (id, thunkAPI) => {
    try {
      await ExcessStockService.deleteExcessStock(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const unArchiveExcessStock = createAsyncThunk(
  'excessStock/unArchiveExcessStock',
  async (id, thunkAPI) => {
    try {
      await ExcessStockService.unArchiveExcessStock(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

const initialState = {
  data: [], // List
  list: [],
  totalPages: 0,
  currentPage: 1,
  totalRecord: 0,
  totalBundleSummary: 0,
  status: 'idle',
  error: null,
  loading: false,
  hasMore: true,
};

const ExcessStockSlice = createSlice({
  name: 'excessStock',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetexcessStockData: state => {
      state.data = []; // This will clear the list
    },
    resetexcessStockList: state => {
      state.list = []; // This will clear the list
    },
    resetexcessStockListBundle: state => {
      state.listBundles = []; // This will clear the list
    },
    resetCurrentexcessStockPage: state => {
      state.currentPage = 1;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchExcessStockBundlesSummary.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchExcessStockBundlesSummary.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;

        state.data = action?.payload?.results?.data || []; // Correctly access the data array
        state.totalRecord = action?.payload?.count || 0; // Handle count (total records)
        state.totalBundleSummary = action.payload.count || 0;
        state.totalPages = Math.ceil(
          (action.payload.count || 0) / action.meta.arg.limit,
        ); // Handle totalPages
        state.currentPage = action?.payload.next ? fetchedPage + 1 : fetchedPage;
        //state.list = [ ...action?.payload?.results?.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchExcessStockBundlesSummary.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });

    builder
      .addCase(fetchExcessBundlesSummary.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchExcessBundlesSummary.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecordBundles = action.payload.count || 0; // Handle count (total records)
        state.totalBundlePages = Math.ceil(
          (action.payload.count || 0) / action.meta.arg.limit,
        ); // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.listBundles = [
          
          ...action.payload.results.data,
        ];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchExcessBundlesSummary.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchExcessStockBundles.pending, state => {
        state.statusBundles = 'loading';
      })
      .addCase(fetchExcessStockBundles.fulfilled, (state, action) => {
        state.statusBundles = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchExcessStockBundles.rejected, (state, action) => {
        state.statusBundles = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchArchivedExcessStockBundlesSummary.pending, state => {
        state.status = 'loading';
      })
      .addCase(
        fetchArchivedExcessStockBundlesSummary.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          const fetchedPage = action.payload.page || state.currentPage;
          state.data = action.payload.results.data || []; // Update to match your API response
          state.totalRecord = action.payload.count || 0; // Handle count (total records)
          state.totalPages = action.payload.totalPages || 0; // Handle totalPages
          state.currentPage = action.payload.next
            ? fetchedPage + 1
            : fetchedPage;
          state.list = [ ...action.payload.results.data];
          state.hasMore = !!action.payload.next;
        },
      )
      .addCase(
        fetchArchivedExcessStockBundlesSummary.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
        },
      );
    builder
      .addCase(fetchArchivedExcessStockBundles.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchArchivedExcessStockBundles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchArchivedExcessStockBundles.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(createExcessStock.pending, state => {
        state.status = 'loading';
      })
      .addCase(createExcessStock.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(createExcessStock.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
    builder
      .addCase(updateExcessStock.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateExcessStock.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const updateDieProfile = action.payload;
        const index = state.data.findIndex(
          group => group.id === updateDieProfile.id,
        ); // Find the index of the updated group
        if (index !== -1) {
          state.data[index] = updateDieProfile; // Replace the old group with the updated one
        }
      })
      .addCase(updateExcessStock.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(unArchiveExcessStock.pending, state => {
        state.status = 'loading';
      })
      .addCase(unArchiveExcessStock.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
      })
      .addCase(unArchiveExcessStock.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  resetexcessStockData,
  resetexcessStockList,
  resetexcessStockListBundle,
  resetCurrentexcessStockPage,
} = ExcessStockSlice.actions;
export default ExcessStockSlice.reducer;
